import { Slider } from '@mui/material';
import React from 'react';


function SliderSolo(props) {
    return ( 
        <div className={`flex ${props.type==="dim" ? 'mt-0.5' :'-mt-1.5'}`}>
            <p className={`w-24 md:w-28
                           text-sm text-right pr-4 md:ml-0
                           ${props.type==="dim" ? `text-base md:text-lg font-semibold ml-12 mt-2` 
                           : 'text-base md:text-sm ml-4 md:ml-8 mt-2.5'}`}>{props.name}</p>
            <div className={`${props.type==="dim" ? 'w-36 md:w-44' : 'w-36'}`}>
                <Slider key={props.name}
                        name={props.name}
                        size={`${props.type==="dim" ? ``: `small`}`}
                        defaultValue={0}
                        value={props.value}
                        marks={false}
                        min={0}
                        max={props.type==="dim" ? 100 : 1}
                        step={props.type==="dim" ? 1 : 0.005}
                        valueLabelDisplay="auto"
                        onChange={props.sliderChange}
                        style={{color: '#e31c79'}}/>
            </div>
        </div>
     );
}

export default SliderSolo;